import { financialProfileContentPageNav } from "../financial-profile/routes";
import { buildBreadcrumbNavigationConfig } from "../shared/helpers/buildBreadcrumbNavigationConfig";
import { HighlightsContainer } from "./pages/highlights.container";

const highlightsContentPath = "/highlights";

const highlightsContentPageNav = buildBreadcrumbNavigationConfig(
  "Highlights",
  highlightsContentPath
);

export const routes = [
  {
    path: highlightsContentPath,
    Component: HighlightsContainer,
    navigation: [financialProfileContentPageNav, highlightsContentPageNav],
    exact: true,
    isPrivate: true,
  },
];
